import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { format } from 'date-fns'

import { useNotifications } from 'app/application/application'
import { useApi } from 'app/common/application'

import {
  GetMatchedTreatmentCountsGetRequest,
  GetMatchedTreatmentCountsGetResponse,
  mapConversions,
} from '../types'

const useConversion = (audienceId: string) => {
  const { create } = useApi()
  const { createNotification } = useNotifications()
  const { t } = useTranslation('error')

  const getConversions = useCallback(
    (fromDate: Date, toDate: Date) =>
      create<GetMatchedTreatmentCountsGetRequest, GetMatchedTreatmentCountsGetResponse>(
        '/conversions/getMatchedTreatmentsCount',
        {
          // all
          content: {
            audienceId,
            fromDate: format(fromDate, 'yyyy-MM-dd'),
            toDate: format(toDate, 'yyyy-MM-dd'),
          },
        },
      ).then((result) => {
        if (result.ok) {
          return mapConversions(result.val.data)
        } else {
          if (result.val.code !== 423)
            createNotification({
              message: result.val.message,
              title: t(`http.${result.val.code}`),
              type: 'error',
            })

          return {}
        }
      }),

    [audienceId, create, createNotification, t],
  )

  return {
    getConversions,
  }
}

export default useConversion
